import React from 'react';
import { BoxProps as MuiBoxProps } from '@mui/material';
import { StyledBox } from './Box.style';

export interface BoxProps extends Omit<MuiBoxProps, 'component'> {
  /**
   * The component used for the root node. Either a string to use a HTML element or a component.
   */
  component?: React.ElementType;
  /**
   * Whether the box should have a subtle shadow
   */
  elevation?: boolean;
  /**
   * Whether the box should have rounded corners
   */
  rounded?: boolean;
  /**
   * Whether the box should have a border
   */
  bordered?: boolean;
  /**
   * The background color variant
   */
  bgVariant?: 'default' | 'paper' | 'paper2' | 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info';
}

export const Box: React.FC<BoxProps> = ({
  children,
  elevation = false,
  rounded = false,
  bordered = false,
  bgVariant = 'default',
  ...props
}) => {
  return (
    <StyledBox
      elevation={elevation}
      rounded={rounded}
      bordered={bordered}
      bgVariant={bgVariant}
      {...props}
    >
      {children}
    </StyledBox>
  );
}; 